import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import React, { useState } from 'react';
import { Icon, Spinner } from '../../subkit-ui';
import { TWInput } from '../TWInput';
import classNames from 'classnames';
import paymentService from '../../services/payments';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var PromoCodeState;

(function (PromoCodeState) {
  PromoCodeState["TEXTFIELD_NOT_SHOWING"] = "textfield-not-showing";
  PromoCodeState["TEXTFIELD_SHOWING"] = "textfield-showing";
})(PromoCodeState || (PromoCodeState = {}));

var PromoCode = function PromoCode(_ref) {
  var order = _ref.order,
      getOrder = _ref.getOrder,
      updateOrder = _ref.updateOrder;

  var _useState = useState(PromoCodeState.TEXTFIELD_NOT_SHOWING),
      state = _useState[0],
      setState = _useState[1];

  var _useState2 = useState(''),
      promoCode = _useState2[0],
      setPromoCode = _useState2[1];

  var _useState3 = useState(false),
      submitting = _useState3[0],
      setSubmitting = _useState3[1];

  var _useState4 = useState({}),
      applyText = _useState4[0],
      setApplyText = _useState4[1];

  var applyPromoCode = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(p) {
      var promoCodeResponse;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (order.planId) {
                _context.next = 2;
                break;
              }

              throw new Error("PromoCode is only implemented for subscriptions: order.planId must be specfied. order.id=".concat(order.id));

            case 2:
              setSubmitting(true);
              setApplyText({});
              _context.next = 6;
              return paymentService.checkPromoCode(order.id, p)["catch"](function () {
                return void 0;
              });

            case 6:
              promoCodeResponse = _context.sent;

              if (!(promoCodeResponse !== null && promoCodeResponse !== void 0 && promoCodeResponse.name && promoCodeResponse !== null && promoCodeResponse !== void 0 && promoCodeResponse.type)) {
                _context.next = 21;
                break;
              }

              setApplyText({
                text: "Added: ".concat(promoCodeResponse.name),
                type: 'message'
              });
              setState(PromoCodeState.TEXTFIELD_NOT_SHOWING);
              _context.t0 = promoCodeResponse.type;
              _context.next = _context.t0 === 'share' ? 13 : _context.t0 === 'stripe' ? 14 : 17;
              break;

            case 13:
              return _context.abrupt("break", 17);

            case 14:
              _context.next = 16;
              return updateOrder(order.id, {
                promoCode: promoCode
              });

            case 16:
              return _context.abrupt("break", 17);

            case 17:
              _context.next = 19;
              return getOrder(order.id);

            case 19:
              _context.next = 22;
              break;

            case 21:
              setApplyText({
                text: "".concat(promoCode, " is not a valid promo code."),
                type: 'error'
              });

            case 22:
              setPromoCode('');
              setSubmitting(false);

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function applyPromoCode(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  if (!order) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "h-14 relative",
      children: [/*#__PURE__*/_jsxs("div", {
        className: classNames('absolute w-full flex pl-1 pt-5 cursor-pointer transition duration-300', {
          'opacity-0 pointer-events-none': state !== PromoCodeState.TEXTFIELD_NOT_SHOWING
        }),
        onClick: function onClick() {
          return setState(PromoCodeState.TEXTFIELD_SHOWING);
        },
        children: [/*#__PURE__*/_jsx(Icon, {
          name: "plus",
          type: "regular",
          className: "mr-2 text-subkit-primary self-center"
        }), /*#__PURE__*/_jsx("div", {
          className: "fw-500 text-subkit-primary",
          children: "Add a promo code"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: classNames('absolute w-full flex transition duration-300', {
          'opacity-0 pointer-events-none': state !== PromoCodeState.TEXTFIELD_SHOWING
        }),
        children: [/*#__PURE__*/_jsx("div", {
          className: "flex-1",
          children: /*#__PURE__*/_jsx(TWInput, {
            format: "rounded",
            placeholder: "Promo code",
            name: "promoCode",
            value: promoCode,
            onChange: function onChange(e) {
              e.preventDefault();
              setPromoCode(e.target.value);
            },
            onKeyDown: function onKeyDown(e) {
              if (e.which === 13 && promoCode) {
                e.preventDefault();
                applyPromoCode(promoCode);
              }
            }
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "w-20 self-center cursor-pointer text-center",
          children: /*#__PURE__*/_jsxs("div", {
            className: classNames('fw-500 transition duration-500', {
              'text-subkit-primary': promoCode !== '',
              'text-gray-500': promoCode === ''
            }),
            onClick: function onClick() {
              if (submitting) return;

              if (promoCode === '') {
                setApplyText({});
                setState(PromoCodeState.TEXTFIELD_NOT_SHOWING);
              } else {
                applyPromoCode(promoCode);
              }
            },
            children: [!submitting && promoCode === '' && /*#__PURE__*/_jsx(_Fragment, {
              children: "Cancel"
            }), !submitting && promoCode !== '' && /*#__PURE__*/_jsx(_Fragment, {
              children: "Apply"
            }), submitting && /*#__PURE__*/_jsx(Spinner, {})]
          })
        })]
      })]
    }), applyText && /*#__PURE__*/_jsx("div", {
      className: classNames('mt-2 fw-500', {
        'text-red-900': applyText.type === 'error',
        'text-green-700': applyText.type === 'message'
      }),
      children: applyText.text
    })]
  });
};

export default PromoCode;